import React, { useContext } from "react";
import Layout from '../../Components/VC/VcCompanyLayout'
import MainMenu from '../../Components/VC/AllMainmenu'
import Card from '../../Components/ListPageCard/IpoCard'
import Table from '../../Components/AllTableComponent'
// import {PE_TABLE_QUERY} from '../../Queries/Pe';

import RefineSearch from '../../Components/RefineSearchComponent'
import FilterTag from '../../Components/Tag'
// import chatPopupIcon from '../../images/chatPopupIcon.png'
// import ChatPopup from '../../Components/ChatPopup'
import Constants from '../../Constants'
import BackedIPORefineSearch from '../../Components/RefineSearch/BackedIPORefineSearch'
import { useLocation } from "react-router";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { Switch, Tooltip } from "antd";
import { UserContext } from "../../Contexts/UserContext";
import ToggleDealsViewButton from "../../Components/ToggleDealsView";
import ChartPopup from "../../Components/ChartPopup/ChartPopup";
import useChartAnalytics from "../../hooks/useChartAnalytics";
/**
 * The function `BackedIpoVc` is a React component that renders a layout with a top navigation bar, a
 * sidebar, and a main content area, which includes a filter tag, a main menu, and a table.
 * @returns The function `BackedIpoVc` returns JSX elements wrapped in a `Layout` component. The
 * returned JSX structure includes a top navigation section, a bottom section with a narrow sidebar and
 * a main area, and a secondary column (hidden on smaller screens). The main area includes a primary
 * column and a secondary column. The primary column contains a section with content, including a
 * `FilterTag`
 */
function BackedIpoVc() {
    // const [showModal, setShowModal] = React.useState(false);
    const location = useLocation(); 
    const { pathname } = useLocation(); 
 
    const { refineSearchFilters, dealsView, setDealsView, switchValue, setSwitchValue, isMobile } = useContext(PeFilterContext);
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const { isDirectoryUser } = useContext(UserContext);

    // Use chart analytics hook
    const {
        showChartPopup,
        setShowChartPopup,
        currentChartData,
        setCurrentChartData,
        isChartLoading,
        setIsChartLoading,
        currentShowBy,
        fallbackChartData,
        getAvailableShowByOptions,
        handleChartIconClick,
        handleShowByChange,
        interval,
        handleIntervalChange,
        period,
        handlePeriodChange
    } = useChartAnalytics("backedIpos-vc", pathname);

    const dealsViewHandler = (checked) =>{
        setSwitchValue(checked);
        if(checked){ setDealsView(true) }else setDealsView(false);
    }

    return (
        <Layout>
         <div className="flex h-screen flex-col">
                    {/* Bottom section */}
                    <div className="flex min-h-0 flex-1">
                        {/* Narrow sidebar*/}
                        {/* Main area */}
                        <main className= {isFromGlobalSearch() ? "min-w-0 flex-1 border-t border-gray-200 flex":"min-w-0 mt-12 flex-1 border-t border-gray-200 flex"}>
                            {/* Primary column */}
                            <section
                                className="flex h-full min-w-0 flex-1 overflow-y-auto flex-col lg:order-last">
                                {/* Your content */}
                                <div className="mr-[4.25rem] flex justify-between items-center">
                                <div></div>
                                <ToggleDealsViewButton />
                                </div>
                                <MainMenu 
                                    active={3} 
                                    menu="VC-IPOs" 
                                    primaryTypeMasterId={Constants.primaryMasterIds.vcId}
                                    subTypeMasterId={Constants.primaryMasterSubIds.vc_backed_ipos_id}
                                    typeId={Constants.moduleIds.companiesId}
                                    exportFileName={Constants.exportNames.vc_company_ipo}
                                    handleChartIconClick={handleChartIconClick}
                                    isChartLoading={isChartLoading}
                                />
                                <div className='overflow-y-auto'>
                                    <Table menu="backedIpos-vc" sub_type_master_id={Constants.subCategoryIds.vc_backed_ipos_id}/>
                                </div>
                            </section>
                        </main>
                    </div>
                   
                </div>
                
                {/* Chart Popup */}
                {showChartPopup && (
                    <ChartPopup
                        isOpen={showChartPopup}
                        onClose={() => {
                            setShowChartPopup(false);
                            setIsChartLoading(false);
                            setCurrentChartData(null);
                        }}
                        data={currentChartData || fallbackChartData}
                        isLoading={isChartLoading}
                        showBy={currentShowBy}
                        availableShowByOptions={getAvailableShowByOptions()}
                        onShowByChange={handleShowByChange}
                        interval={interval}
                        onIntervalChange={handleIntervalChange}
                        period={period}
                        onPeriodChange={handlePeriodChange}
                        menuType="backedIpos-vc"
                        subType="VC Backed IPOs"
                    />
                )}
        </Layout>
    )
}

export default BackedIpoVc
